import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, nextResource }) => {
    return present(
      repository
        .editResource(resource, nextResource)
        .catch(() => Promise.reject({ resource, nextResource })),
    );
  };
}

export type { Interactor };

export { createInteractor };
